import React, { useState } from 'react';
import { Row, Modal, Checkbox, Col, Button, Input, notification } from 'antd';
const { TextArea } = Input;
import { setIsShowFeedback } from '@/store/modules/chatSlice.js';
import { useDispatch, useSelector } from 'react-redux';
import { useRequest } from 'ahooks';
import { updateConversationAPI } from '@/services/chat.js';
import { useParams } from 'react-router-dom';
import { insertFeedbackAPI } from '@/services/feedback.js';
import { useTranslation } from 'react-i18next';

const columnSpan = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
  xxl: 6,
};

const feedbackModal = props => {
  const { typeModal } = props;
  const { externalRef } = useParams();
  const { t } = useTranslation(['feedback', 'translation', 'chat']);

  const dispatch = useDispatch();
  const [checkedValues, setCheckedValues] = useState([]);
  const [textValue, setTextValue] = useState('');
  const { isShowFeedback } = useSelector(state => state.chat);

  const { runAsync } = useRequest(updateConversationAPI, {
    manual: true,
  });
  const { runAsync: runAsyncFeedback } = useRequest(insertFeedbackAPI, {
    manual: true,
  });

  const handleOk = () => {
    if (checkedValues.length === 0 && textValue === '') {
      notification.error({ message: t('feedback:notification.selectOrFill') });
      return;
    }

    if (typeModal === 'chat') {
      runAsync({
        externalRef: externalRef,
        isFeedback: 1,
      });
    }

    //insertFeedback
    runAsyncFeedback({
      conversationId: externalRef,
      checkId: checkedValues,
      feedbackContent: textValue,
    });

    dispatch(setIsShowFeedback(false));
    // setIsModalOpen(false);
    setCheckedValues([]);
    setTextValue('');
  };
  const handleCancel = () => {
    if (typeModal === 'chat') {
      runAsync({
        externalRef: externalRef,
        isFeedback: 2,
      });
    }
    dispatch(setIsShowFeedback(false));
    setCheckedValues([]);
    setTextValue('');
    // setIsModalOpen(false);
  };

  const handleCheckboxChange = checkedValues => {
    setCheckedValues(checkedValues);
  };

  const handleTextChange = checkedValues => {
    setTextValue(checkedValues.target.value);
  };

  // Feedback弹窗
  return (
    <Modal
      title={t('feedback:modal.title')}
      open={isShowFeedback}
      onCancel={handleCancel}
      centered
      width="70%"
      footer={
        <div style={{ display: 'flex', justifyContent: 'center', gap: '40px' }}>
          <Button shape="round" onClick={handleCancel}>
            {t('translation:cancel')}
          </Button>
          <Button shape="round" type="primary" onClick={handleOk}>
            {t('translation:submit')}
          </Button>
        </div>
      }
    >
      <Checkbox.Group
        style={{ width: '100%' }}
        onChange={handleCheckboxChange}
        value={checkedValues}
      >
        <Row gutter={[10, 10]}>
          <Col {...columnSpan}>
            <Checkbox value="1">{t('chat:riskBubble.fields.involvedOrganization')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="2">{t('chat:riskBubble.fields.actionableInsights')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="3">{t('chat:riskBubble.fields.possibleIncidentType')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="4">{t('chat:riskBubble.fields.explanation')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="5">{t('chat:riskBubble.fields.advice')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="6">{t('chat:riskBubble.fields.tips')}</Checkbox>
          </Col>
          <Col {...columnSpan}>
            <Checkbox value="7">{t('chat:riskBubble.fields.other')}</Checkbox>
          </Col>
        </Row>
      </Checkbox.Group>
      <TextArea
        showCount
        maxLength={400}
        onChange={handleTextChange}
        value={textValue}
        placeholder={t('feedback:modal.placeholder')}
        style={{ height: 120, resize: 'none', marginTop: '1rem' }}
      />
      <Row justify="center" style={{ textAlign: 'center', marginTop: '1rem' }}>
        <Col>{t('feedback:modal.emailNotice')}</Col>
      </Row>
    </Modal>
  );
};

export default feedbackModal;
